<template>
    <div class="storyboard noSelect">
        <div class="leftSet">
            <div class="leftTil" @click="createTeamSharing()">
                <FSpanTil title="故事" fontSize="20" IconSize="20">新建共享组</FSpanTil>
                <div class="divSvg">
                    <FSvg title="圆加" color="#666" IconSize="22"></FSvg>
                </div>
            </div>
            <div class="leftList">
                <div class="list_til noSelect">
                    <div class="divSvg">
                        <FSvg title="列表" color="#fff" hoverColor="#fff" IconSize="20"></FSvg>
                    </div>
                    <span class="divSpan">团队组列表</span>
                </div>
                <ul class="listUl">
                    <li v-for="(item,index) in teamSharingList"
                        :class="{addValList:activeStory.id === item.id}"
                        @click="selectTeamSharingList(item)"
                        @dblclick="menuOperation('setContents')">
                        {{item.name}}
                    </li>
                </ul>
                <div class="noData" v-if="isNull(teamSharingList)">暂无数据</div>
            </div>
        </div>
        <div class="rigSet">
            <div class="rigTil">
                <div class="div_svg">
                    <FSvg title="故事" color="#333" hoverColor="#333" IconSize="20"></FSvg>
                </div>
                <span>{{activeStory.name}}</span>
                <el-dropdown class="updBtn" v-if="!isNull(teamSharingList)">
                <span class="el-dropdown-link">
                    <FSvg color="#000" title="更多"></FSvg>
                </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in menuList"
                                          @click.native="menuOperation(item.operation)">{{item.name}}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="rigCount">
                <el-scrollbar ref="scrollbar"
                              :native="false">
                    <div class="FCanvas_Page"
                         :style="{height: canvasPage.height + 'px',width:canvasPage.width + 'px'}">
                        <div class="FCharsDrog"
                             v-for="(item,index) in dragElementList"
                             :style="{
                                     background:item.backColor,
                                     height:item.transF.height+'px',
                                     width:item.transF.width+'px',
                                     top:item.transF.y+'px',
                                     left:item.transF.x+'px',
                                     }">
                            <div class="charts_box" v-if="item.type === 0"
                                 :id="'snap_shot_'+item.chartData.id"></div>
                            <div class="text_input" v-if="item.type === 1">
                                <!--  <FUpload v-model="item.content" @change="textChange(item,index)"-->
                                <!--           @focus="onfocus"></FUpload>-->
                                <quill-editor
                                        v-model="item.content"
                                ></quill-editor>
                            </div>
                            <img class="text_img"
                                 draggable="false"
                                 :src="item.imgUrl"
                                 v-if="item.type === 2">
                            <svg class="text_svg" id="text_svg" v-if="item.type === 3">
                                <rect class="rect" v-if="item.svg.type === 'rect'" :width="item.transF.width"
                                      :height="item.transF.height"
                                      :style="{fill:item.svg.fillColor,stroke:item.svg.strokeColor,strokeWidth:item.svg.strokeWidth+'px'}"/>
                                <ellipse class="ellipse" v-if="item.svg.type === 'ellipse'"
                                         :cx="item.transF.width" :cy="item.transF.height"
                                         :rx="item.transF.width" :ry="item.transF.height"
                                         :style="{fill:item.svg.fillColor,stroke:item.svg.strokeColor,strokeWidth:item.svg.strokeWidth+'px'}"/>
                                <line class="line" v-if="item.svg.type === 'line'" x1="0" y1="0"
                                      :x2="item.transF.width" :y2="item.transF.height"
                                      style="stroke:rgb(99,99,99);stroke-width:2"/>
                            </svg>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
            <div class="noData" v-if="totalCountShow">暂无数据</div>
        </div>
        <!--团队分享 -->
        <FDialog class="teamSharing_dialog" :dialog="teamSharingDialog" @open="getL1Ztree()" title="团队人员选择"
                 @close="teamSharingDialog = false">
            <ul id="treeDemo" class="ztree"></ul>
            <div class="teamSharing_submission">
                <FBtn title="确定" :IconSize="20" :type="2" @click="submitTS"></FBtn>
            </div>
        </FDialog>
        <!--链接分享 -->
        <FDialog class="teamSharing_dialog" :dialog="linkSharing.show" @open="linkSharing.show = true" title="链接共享"
                 @close="linkSharing.show = false,linkSharing.success=false">
            <div class="title">请选择链接有效时效:</div>
            <div class="select">
                <el-radio v-model="linkSharing.linkSharingDay" label="1">1日</el-radio>
                <el-radio v-model="linkSharing.linkSharingDay" label="7">7日</el-radio>
                <el-radio v-model="linkSharing.linkSharingDay" label="30">30日</el-radio>
                <el-radio v-model="linkSharing.linkSharingDay" label="永久">永久</el-radio>
            </div>
            <div class="teamSharing_submission">
                <FBtn title="确定" :IconSize="20" :type="2" @click="submitLS"></FBtn>
            </div>
        </FDialog>
        <!--链接分享 -->
        <FDialog class="teamSharing_dialog" :dialog="link.show" @open="link.show = true" title="链接共享"
                 @close="link.show = false">
            <div class="title">将链接共享给其他人即可分享屏幕:</div>
            <div class="url">链接:</div>
            <el-link class="url" type="primary" @click="jumpSetContents(activeStory.id)" :href="linkSharing.url+'?storyBoardID='+activeStory.id">{{linkSharing.url}}?storyBoardID={{activeStory.id}}</el-link>
            <div class="url">验证码:</div>
            <textarea id ='verification' cols="20" rows="1" readonly>{{linkSharing.dataTabel}}</textarea>
            <div class="teamSharing_submission">
                <FBtn title="点击复制验证码" :IconSize="20" :type="2" @click="clickCopy"></FBtn>
            </div>
        </FDialog>
    </div>
</template>

<script>
    import {
        //获取故事版内容详情
        getTeamSharingContent,

    } from '@/assets/axios/teamSharing/setContents'
    import modules from '../charts/script/modules'
    import {
        //获取中心管控列表
        getTeamSharingList,
        //创建新组查看名字是否重复
        getTeamSharingUserIdentical,
        //添加或修改中心管控
        addorModifyTeamSharing,
        //删除中心管控组
        removeTeamSharing,
        //获取当前用户组下面的成员列表
        GetTeamSharingMembers,
        //给故事版添加团队分享人员
        addTeamSharingPersonnel,
        //给故事版添加链接分享
        // createTeamSharingLinkShare
    } from '@/assets/axios/teamSharing/teamSharing'

    export default {
        name: 'teamSharing',
        components: {},
        props: [],
        data() {
            let _this = this;
            return {
                //故事版列表
                teamSharingList: [],
                //故事版列表中选中的数据
                activeStory: {
                    id: null,
                    name: ''
                },
                //内容展示列表
                dragElementList: [],
                //是否由内容
                totalCountShow: false,
                //大屏尺寸
                canvasPage: {
                    height: 1080,
                    width: 1200
                },
                //菜单列表
                menuList: [
                    {
                        name: '编辑',
                        operation: 'setContents'
                    },
                    {
                        name: '团队分享',
                        operation: 'teamSharing'
                    },
                    {
                        name: '链接共享',
                        operation: 'linkSharing'
                    },
                    {
                        name: '删除',
                        operation: 'removeTeamSharing'
                    },
                ],
                //中心管控弹框列表
                teamSharingDialog: false,
                // 中心管控树形配置 ztree
                setting: {
                    check: {
                        enable: true
                    },
                    data: {
                        simpleData: {
                            enable: true
                        },
                        key: {
                            children: 'children',
                            name: 'name'
                        }
                    },
                    callback: {
                        //点击
                        onClick: (e, treeId, treeNode) => {
                            var treeObj = $.fn.zTree.getZTreeObj("treeDemo"),
                                nodes = treeObj.getCheckedNodes(true),
                                v = "";
                            for (var i = 0; i < nodes.length; i++) {
                                v += nodes[i].name + ",";
                            }

                        },
                        onCheck: (e, treeId, treeNode) => {
                            var treeObj = $.fn.zTree.getZTreeObj("treeDemo");
                            let a = [];
                            treeObj.getCheckedNodes().map((val) => {
                                if (val.isParent === false) {
                                    a.push(val.id);
                                }
                            })
                            _this.memberList = a;
                        }
                    },
                },
                // 中心管控树形数据
                zNodes: [],
                // 中心管控提交的人员数组
                memberList: [],
                //链接共享弹框
                linkSharing: {
                    show: false,
                    //链接共享
                    linkSharingDay: '',
                    //链接共享地址
                    url: 'http://47.105.165.74:8057/#/linkSharing',
                    //验证码
                    dataTabel: ''
                },
                //链接弹框
                link: {
                    show: false
                }
            }
        },
        methods: {
            // 获取故事版列表
            getTeamSharingList() {
                // 获取故事版列表
                getTeamSharingList().then((data) => {
                    if (data.code === 200) {
                        if(data.data.dataTabel !==""){
                            this.teamSharingList = data.data.dataTabel;
                            this.activeStory = this.teamSharingList[0];
                            this.getElementContent(this.activeStory.id)
                        }
                    }
                })
            },
            // 获取页面内容
            getElementContent(id) {
                if (id !== undefined) {
                    getTeamSharingContent({storyBoardID: id}).then((res) => {
                        if (res.code === 200) {
                            if(res.message !== '无值'){
                                this.dragElementList = [];
                                res.data.dataTable.info.map((val) => {
                                    let a = {};
                                    a = JSON.parse(val.contentJson);
                                    a.chartBoxId = val.id;
                                    a.storyBoardID = val.storyBoardID;
                                    if (a.type === 0) {
                                        this.createChart(a.chartData, a.chartBoxId);
                                    }
                                    this.dragElementList.unshift(a);
                                });
                                this.zIndexList = JSON.parse(res.data.dataTable.rankJson) || [];
                                //根据zIndexList 重新排列 dragElementList
                                this.setElementContentIndexRefresh();
                                this.rearrangedragElementList('dragList');
                                this.canvasPage.height = res.data.dataTable.height;
                                // this.dragElementList = JSON.parse(res.data.dataTable[0].contentJson);
                                // this.canvasPage.height = res.data.dataTable[0].height;
                            }
                        }
                    })
                }
            },
            // 刷新dragElementList中的zindex
            setElementContentIndexRefresh() {
                this.zIndexList.map((zv) => {
                    this.dragElementList.map((ev) => {
                        if (zv.id === ev.chartBoxId) {
                            ev.transF.zIndex = zv.zIndex;
                        }
                    })
                });
            },
            //根据zIndex重新排列dragElementList
            rearrangedragElementList(type) {
                if(type === 'dragList'){
                    var len = this.dragElementList.length;
                    for (var i = 0; i < len - 1; i++) {
                        for (var j = 0; j < len - 1 - i; j++) {
                            // 相邻元素两两对比，元素交换，大的元素交换到后面
                            if (this.dragElementList[j].transF.zIndex < this.dragElementList[j + 1].transF.zIndex) {
                                var temp = this.dragElementList[j];
                                this.dragElementList[j] = this.dragElementList[j + 1];
                                this.dragElementList[j + 1] = temp;
                            }
                        }
                    }
                }else if(type === 'zIndex'){
                    var len = this.zIndexList.length;
                    for (var i = 0; i < len - 1; i++) {
                        for (var j = 0; j < len - 1 - i; j++) {
                            // 相邻元素两两对比，元素交换，大的元素交换到后面
                            if (this.zIndexList[j].zIndex < this.zIndexList[j + 1].zIndex) {
                                var temp = this.zIndexList[j];
                                this.zIndexList[j] = this.zIndexList[j + 1];
                                this.zIndexList[j + 1] = temp;
                            }
                        }
                    }
                    this.setElementContentIndexRefresh();
                }

            },
            //创建新的故事版
            createTeamSharing() {
                this.$prompt('请输入共享组名称', '创建共享组', {
                    closeOnClickModal: false,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({value}) => {
                    getTeamSharingUserIdentical({storyBoardName: value}).then((data) => {
                        if (data.code === 200) {
                            addorModifyTeamSharing(value).then((data) => {
                                if (data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '创建成功！'
                                    });
                                    this.getTeamSharingList()
                                }
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消创建'
                    });
                });
            },
            //选择中心管控内容中的一项
            selectTeamSharingList(item) {
                this.activeStory = item;
                this.getElementContent(this.activeStory.id);
            },
            //生成真实数据图表
            createChart(data,boxId) {
                let oData = data;
                if(boxId !== undefined){
                    oData.id += boxId;
                }
                let modu = modules;
                let nodeData = oData;
                this.$nextTick(() => {
                    this.$store.dispatch('viewDPSnapshot', {modu, nodeData});
                })
            },
            //初始化
            getInitial() {
                this.getTeamSharingList()
            },
            //菜单操作
            menuOperation(operation) {
                if (operation === 'setContents') {
                    this.$router.push({path: '/setContents', query: {id: this.activeStory.id}})
                } else if (operation === 'teamSharing') {
                    this.teamSharingDialog = true;
                    this.getL1Ztree();
                } else if (operation === 'linkSharing') {
                    this.linkSharing.show = true
                } else if (operation === 'removeTeamSharing') {
                    this.$alert('删除后无法恢复，还要继续删除吗？', '删除共享组', {
                        confirmButtonText: '确定',
                        callback: action => {
                            removeTeamSharing({'storyBoardID': this.activeStory.id}).then((data) => {
                                if (data.code === 200) {
                                    this.getTeamSharingList();
                                    this.$message({
                                        type: 'success',
                                        message: `删除成功！`
                                    });
                                }
                            })

                        }
                    });

                }
            },
            //团队分享功能 获取限权人员列表 并且加入
            getL1Ztree() {
                GetTeamSharingMembers().then(res => {
                    if (res.code === 200) {
                        this.zNodes = res.data.dataTable
                    }
                })
                setTimeout(() => {
                    $.fn.zTree.init($('#treeDemo'), this.setting, this.zNodes);
                }, 200)
            },
            //提交团队分享
            submitTS() {
                let data = {
                    "storyBoardID": this.activeStory.id,
                    "groupMemberID": this.memberList.toString(),
                    "accesslink": `${this.linkSharing.url}?storyBoardID=${this.activeStory.id}`,
                };
                addTeamSharingPersonnel(data).then(res => {
                    if (res.code === 200) {
                        this.teamSharingDialog = false;
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                    }
                })
            },
            //链接共享提交
            submitLS() {
                let data = {
                    "storyBoardID": this.activeStory.id,
                    "sharingTime": this.linkSharing.linkSharingDay,
                    "accesslink": `${this.linkSharing.url}?storyBoardID=${this.activeStory.id}`,
                };
                createTeamSharingLinkShare(data).then(res => {
                    if (res.code === 200) {
                        this.linkSharing.dataTabel = res.data.dataTabel;
                        this.linkSharing.show = false;
                        this.link.show = true;
                    }
                })
            },
            //复制验证码
            clickCopy() {
                var a = document.getElementById("verification");
                a.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message({
                    message: '复制成功！',
                    type: 'success'
                });
            },
            //跳转至displayWindow
            jumpSetContents(id) {

            },
        },
        mounted() {
            this.getInitial();
            this.getL1Ztree();
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    @borderRadio: 5px;
    @borderColor: #ededed;
    @shadow: 0 0 15px @h_top_backColor;


    .storyboard {
        position: relative;
        background-color: @h_main_backColor !important;
        padding: 0 !important;

        .leftSet {
            width: 17%;
            height: 100%;
            margin-right: 1%;
            float: left;
            display: inline-block;
            .noSelect;


            .leftTil {
                background-color: @h_path_backColor;
                border-radius: @borderRadio;
                padding: 7px 5px;
                line-height: 30px;
                position: relative;
                cursor: pointer !important;

                .FSpanTil {
                    vertical-align: middle;
                    max-width: 80%;

                    > div {
                        cursor: pointer;
                    }
                }

                .divSvg {
                    display: inline-block;
                    float: right;
                    width: 30px;
                    height: 30px;
                    margin-top: 1px;
                }
            }

            .leftList {
                margin-top: 15px;
                display: inline-block;
                width: 100%;
                height: calc(100% - 15px - 30px - 14px);
                background-color: @h_path_backColor;
                border-radius: @borderRadio;
                position: relative;

                .list_til {
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    border-top-right-radius: @borderRadio;
                    border-top-left-radius: @borderRadio;
                    background-color: hsl(@green, 90%);
                    padding: 0 10px;
                    white-space: normal;

                    .divSvg {
                        display: inline-block;
                        float: left;
                        width: 30px;
                        height: 30px;
                        margin-top: -3px;

                        > .FSvg {
                            cursor: auto;
                        }
                    }

                    .divSpan {
                        color: #fff;
                        display: inline-block;
                        width: calc(100% - 60px);
                        .text_oneLine;
                        float: left;
                        font-size: 18px;
                    }
                }

                .listUl {
                    width: 100%;
                    height: calc(100% - 40px - 10px);
                    border-bottom-right-radius: @borderRadio;
                    border-bottom-left-radius: @borderRadio;
                    overflow-y: auto;
                    overflow-x: hidden;

                    > li {
                        width: 100%;
                        line-height: 40px;
                        padding: 0 10px;
                        color: hsl(@fontColor, 0.8);
                        font-size: 16px;
                        cursor: pointer;
                        letter-spacing: 1px;
                        .text_oneLine;
                    }

                    > li:hover {
                        background-color: hsl(@green, 10%);
                    }

                    .addValList {
                        background-color: hsl(@green, 30%) !important;
                    }
                }

                .noData {
                    position: absolute;
                    transform: translate(-50%, -50%);
                    left: 50%;
                    top: 50%;
                    font-size: 26px;
                    color: #999;
                }

            }
        }

        .rigSet {
            background-color: @h_path_backColor;
            border-radius: @borderRadio;
            height: 100%;
            width: calc(100% - 18%);
            float: left;
            display: inline-block;
            padding: 5px 5px 20px;
            position: relative;

            > .rigTil {
                line-height: 30px;
                padding: 10px 15px 0;

                > .div_svg {
                    display: inline-block;
                    float: left;
                    vertical-align: middle;
                    margin-top: -2px;
                }

                > span {
                    display: inline-block;
                    margin-left: 10px;
                    color: @fontColor;
                    float: left;
                    font-size: 20px;
                    letter-spacing: 2px;
                    max-width: 70%;
                    .text_oneLine;
                }

                .updBtn {
                    display: inline-block;
                    float: right;
                }

                .menu {
                    position: absolute;
                    width: 100px;
                    border: @green solid 1px;
                    border-radius: 5px;
                    right: 50px;
                    top: 30px;
                    background: #fff;
                    z-index: 999;
                    padding: 6px;

                    > ul {
                        > li {
                            cursor: pointer;
                        }

                        > li:hover {
                            color: @green;
                        }
                    }

                }
            }

            > .rigCount {
                width: 100%;
                height: calc(100% - 25px);
                padding: 15px;
                overflow-y: auto;
                overflow-x: hidden;


                .el-scrollbar {
                    width: 100%;
                    height: 100%;

                    .el-scrollbar__wrap {
                        overflow-x: hidden;
                    }

                    .el-scrollbar__view {
                        > div {
                            position: relative;
                            transform-origin: 0 0;
                        }
                    }
                }

                .FCanvas_Page {
                    position: relative;
                    margin: 0 auto;
                    background: #fff;
                    width: 1200px;
                    height: 1080px;

                    .FCharsDrog {
                        /*background-color: #00a65a;*/
                        z-index: 0;
                        position: absolute;

                        .charts_box {
                            width: 100%;
                            height: 100%;
                            color: #fff;
                            font-size: 30px;
                            text-align: center;
                        }

                        .text_input {
                            width: 100%;
                            height: 100%;
                            outline: none;
                            resize: none;
                            border: none;
                            background: transparent;
                            /*transform: scale(0.96);*/

                            .quill-editor {
                                position: relative;
                                width: 100%;
                                height: 100%;
                                .ql-toolbar {
                                    display: none;
                                }
                                .ql-container {
                                    border: none;
                                    .ql-editor{
                                        overflow: hidden;
                                    }
                                }
                            }
                        }

                        .text_img {
                            width: 100%;
                            height: 100%;
                        }

                        .text_svg {
                            width: 100%;
                            height: 100%;

                            > * {
                                width: 100%;
                                height: 100%;
                            }

                            .ellipse {
                                transform: scale(0.498);
                            }
                        }
                    }

                    .chart-barder {
                        position: absolute;
                        z-index: 999;
                    }

                    .linBorTop {
                        border-top: 1px dashed #999;
                    }

                    .linBorLeft {
                        border-left: 1px dashed #999;
                    }

                    .chart-xy-barder-top {
                        width: 100%;
                        .linBorTop;
                    }

                    .chart-xy-barder-bottom {
                        width: 100%;
                        .linBorTop;
                    }

                    .chart-xy-barder-left {
                        height: 100%;
                        .linBorLeft;
                    }

                    .chart-xy-barder-right {
                        height: 100%;
                        .linBorLeft;
                    }
                }
            }

            .noData {
                position: absolute;
                transform: translate(-50%, -50%);
                left: 50%;
                top: 50%;
                font-size: 26px;
                color: #999;
            }
        }

        .teamSharing_dialog {
            .title {
                font-size: 16px;
                margin-bottom: 20px;
                color: #000;
            }

            .select {
                line-height: 20px;
                margin-bottom: 20px;
            }

            .url {
                line-height: 20px;
                margin-bottom: 10px;
            }
            #verification{
                border: none;
                resize: none;
                outline:none
            }

            .teamSharing_submission {
                float: right;
            }
        }
    }
</style>
